import React from 'react';
import styles from './Button.module.css';
import ButtonBase, {ButtonBaseProps} from './ButtonBase';

interface ButtonSolidProps extends ButtonBaseProps {
  variant?: 'default' | 'inverted' | 'purple';
  size?: 'small' | 'default';
  loading?: boolean;
  id?: string;
}

export default function ButtonSolid({className, size = 'default', variant = 'default', ...rest}: ButtonSolidProps) {
  const variantClass =
    variant === 'inverted' ? styles.riseBtnSolidInverted : variant === 'purple' ? styles.riseBtnSolidPurple : '';
  const sizeClass = size === 'small' ? styles.btnSizeSmall : '';
  return (
    <ButtonBase
      className={`${styles.riseBtnSolid} rise-btn-solid ${variantClass} ${sizeClass} ${className ?? ''}`}
      {...rest}
    />
  );
}
